import { getRaceGroup, GROUP_NAME } from "enefel/race";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaBiohazard, FaFootballBall } from "react-icons/fa";
import styled from "styled-components";
import CustomTooltip from "../Interface/Tooltip";

import { GiDevilMask, GiSpikeball } from "react-icons/gi";
import { MdSentimentNeutral } from "react-icons/md";

const Wrapper = styled.div`
  margin-top: 3px;
`;

type GroupIconProps = {
  group: string;
};

export const GroupIcon: React.FC<GroupIconProps> = React.memo(({ group }) => {
  const { t } = useTranslation("race");
  const { t: tGlobal } = useTranslation();
  const Icon =
    group === GROUP_NAME.AGILE
      ? FaFootballBall
      : group === GROUP_NAME.CHAOTIC
      ? FaBiohazard
      : group === GROUP_NAME.EXOTIC
      ? GiSpikeball
      : group === GROUP_NAME.VICIOUS
      ? GiDevilMask
      : group === GROUP_NAME.NEUTRAL
      ? MdSentimentNeutral
      : null;

  if (!Icon) {
    return null;
  }

  const description = t(`race:${group} description`, "");

  let compatibilityInfo: React.ReactNode = null;
  if (group === GROUP_NAME.NEUTRAL) {
    const neutralText = tGlobal("t:group neutral compatibility", "");
    if (neutralText) {
      compatibilityInfo = (
        <div
          style={{ marginTop: "0.5em", fontStyle: "italic", fontSize: "0.9em" }}
        >
          {neutralText}
        </div>
      );
    }
  } else {
    const animosityRule = tGlobal("t:group incompatibility rules", "");
    const rerollRule = tGlobal("t:group incompatibility rules reroll", "");
    const toRule = tGlobal("t:group incompatibility rules to", "");
    const pcRule = tGlobal("t:group incompatibility career point", "");

    const rules = [animosityRule, rerollRule, toRule, pcRule].filter(Boolean);

    if (rules.length > 0) {
      compatibilityInfo = (
        <div style={{ marginTop: "0.5em", fontSize: "0.9em" }}>
          {rules.map((rule, index) => (
            <div
              key={index}
              style={{ marginBottom: "0.3em", fontStyle: "italic" }}
            >
              {rule}
            </div>
          ))}
        </div>
      );
    }
  }

  return (
    <CustomTooltip
      placement="top"
      title={
        <div>
          <div style={{ marginBottom: "0.5em" }}>
            <strong>{t(`race:${group}`)}</strong>
          </div>
          {description && (
            <div style={{ marginBottom: "0.5em" }}>{description}</div>
          )}
          {compatibilityInfo}
        </div>
      }
    >
      <Wrapper>
        <Icon />
      </Wrapper>
    </CustomTooltip>
  );
});

type GroupProps = {
  race: string;
};

const Group: React.FC<GroupProps> = React.memo(({ race }) => {
  const group = getRaceGroup(race as any);
  return <GroupIcon group={group} />;
});

export default Group;
